
    const data = {"name":"src/core/icons/identifier","data":{"viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M10 7v2H9v6h1v2H6v-2h1V9H6V7h4m6 0a2 2 0 0 1 2 2v6c0 1.11-.89 2-2 2h-4V7m4 2h-2v6h2V9Z\"/>","originalColors":[],"stopColors":[]}}

            export default data
            